import * as types from "./mutation-type";
import { getPositionsQuery,getPositionsStoreQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getPositions({ commit }, variables = {}) {
    try {
      commit(types.GET_POSITIONS_BEGIN);
      const {
        data: {
          data   
        }
      } = await gqlClient.query({
        query     : variables.isStore ? getPositionsStoreQuery : getPositionsQuery,
        variables : variables
      });
      commit(types.GET_POSITIONS_SUCCESS, variables.isStore ? data.store.positions : data.company.positions);
    } catch (e) {
      commit(types.GET_POSITIONS_ERROR, e);
    }
  },
  async deletePosition({ commit }, id) {
    try {
      commit(types.DELETE_POSITIONS_BEGIN);
      await api.position.deletePositions(id);

      commit(types.DELETE_POSITIONS_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_POSITIONS_ERROR, e);
    }
  },
  //create new position
  async createPosition({ commit }, variables ) { 
    try {
      commit(types.CREATE_POSITION_BEGIN)
      const { data } = await api.position.addPosition(variables)
      commit(types.CREATE_POSITION_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_POSITION_ERROR, e)
    }
  },

  //update position by its id
  async updatePosition({ commit }, { id, data }){
    commit(types.UPDATE_POSITION_BEGIN)
    try {
      const { data:updatedData } = await api.position.update(id,data)
      commit(types.UPDATE_POSITION_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_POSITION_ERROR, error)
    }
  },

  //create position in user_emp section
  async createUserPosition({ commit,rootState }, userData) { 
    try {
      commit(types.ADD_USER_POSITION_BEGIN,userData.userId)
      const { data } = await api.userPosition.addUserPosition(userData)
      commit(types.ADD_USER_POSITION_SUCCESS, { data ,rootState })
    } catch (err) {
      commit(types.ADD_USER_POSITION_ERROR, { err,userId : userData.userId })
    }
  },

  //delete position in user_emp section
  async deleteUserPosition({ commit,rootState }, { id, userId }) {
    try {
      commit(types.DELETE_USER_POSITION_BEGIN, userId);
      await api.userPosition.deleteUserPosition(id);
      commit(types.DELETE_USER_POSITION_SUCCESS, { userId,rootState });
    } catch (err) {
      commit(types.DELETE_USER_POSITION_ERROR, { err, userId });
    }
  }
};

export default actions;
